export default __webpack_public_path__ + "static/media/whatsapp-campaign-1.bf12a15e.png";